import React, { Fragment, memo, useState, useEffect, } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faPlus, faPencilAlt, faTrash, faCheck } from '@fortawesome/free-solid-svg-icons';

import { SiteRutas } from '../../../request/RutasConfig.jsx';

import Config from '../../../components/Util/constantes.js';
import { Notificacion } from '../../../components/Util/Notificacion/Notificacion.jsx';
import ModalSpinner from '../../../components/UI/modalSpinner/modalSpinner.jsx';
import BotonArriba from '../../../components/UI/botonArriba/botonArriba.jsx';

import {
    farmatearMontos, validarDecimal, Round, farmatearFechaEstandar,
    itemSelect, validarIntVig, validaCuenta, datosArbol, validaCCosto
} from '../../../components/Util/Util.jsx';
import { useSessionStorage } from '../../../components/Util/Hooks/useSessionStorage.jsx';
import Swal from 'sweetalert2';
import { Type } from 'react-bootstrap-table2-editor';
import moment from 'moment';

//Seguridad
import Session from '../../../components/Util/session/index.jsx';
import { Obtener_MenuOpciones_Lista_Request, Obtener_MenuNombre_Request } from "../../../request/MenuRequest.jsx";
import ModalSeguridad from "../../Seguridad/ModalSeguridad.jsx";
import optSeg from '../../../components/Util/seg-menu-opciones.js';

import {
    DetallePlantillas_Consultar_Request, EncaPlantillas_Listar_Request, EncaPlantillas_Eliminar_Request
} from '../../../request/MantenimientosRequest.jsx';

import ListaPlantillasInt from './listaPlantillasInt.jsx';

function ListaPlantillas(props) {

    const [SpinnerModal, setSpinnerModal] = useState({ mostrar: false, texto: '', tipo: 3 });
    const [empresa, setEmpresa] = useSessionStorage('empresaCON');
    const [empresaNombre, setEmpresaNombre] = useSessionStorage('empresaNombreCON');
    const [token, setToken] = useSessionStorage('tokenCON', '');
    const [usuario, setUsuario] = useSessionStorage('usuarioCON');
    const [usuarioS, setUsuarioS] = useSessionStorage('UsuarioSCON', '');
    const [Pais, setPais] = useSessionStorage('paisCON');
    let historyMenu = useHistory();
    const [listaDatos, setListaDatos] = useState([]);
    const [filaSeleccionada, setFilaSeleccionada] = useState(undefined);
    const [borrando, setBorrando] = useState(false);

    //Seguridad
    const [menuId, setMenuId] = useState(0);
    const [menuOpciones, setMenuOpciones] = useState([]);
    const [showModalSeguridad, setShowModalSeguridad] = useState(false);
    const [opcionValidar, setOpcionValidar] = useState(0);
    const [opcionValidarNombre, setOpcionValidarNombre] = useState('');

    const columnas = [
        { dataField: 'ID', text: '', csvExport: false, hidden: true },
        { dataField: 'Nombre', text: 'Nombre', csvExport: true, hidden: false, csvText: 'Nombre', editable: false },
        { dataField: 'Descripcion', text: 'Descripción', csvExport: true, hidden: false, csvText: 'Descripcion', editable: false },
    ];

    const botones = [
        { name: "btnVolver", clase: "btn btn-sm pull-right flipInX animated", evento: () => volverAtras(), leyenda: "", iclase: faReply, tooltip: "Volver" },
        { name: "btnUsar", clase: "btn btn-sm pull-right flipInX animated", evento: () => handleUsar(), leyenda: "", iclase: faCheck, tooltip: "Usar" },
        { name: "btnNuevo", clase: "btn btn-sm pull-right flipInX animated", evento: () => handleNuevo(), leyenda: "", iclase: faPlus, tooltip: "Agregar" },
        { name: "btnModificar", clase: "btn btn-sm pull-right flipInX animated", evento: () => handleModificar(), leyenda: "", iclase: faPencilAlt, tooltip: "Modificar" },
        { name: "btnBorrar", clase: "btn btn-sm pull-right flipInX animated", evento: () => handleBorrar(), leyenda: "", iclase: faTrash, tooltip: "Borrar" },];

    const volverAtras = () => {

        historyMenu.push(SiteRutas.Asientos);
        
    }

    const handleUsar = () => {
        
        if (filaSeleccionada) {

            historyMenu.push(`${SiteRutas.MantAsientos}/0/${filaSeleccionada.ID}`);

        } else {

            Notificacion.warning('Debe seleccionar un registro.');

        }

    }

    const handleNuevo = () => {

        historyMenu.push(`${SiteRutas.MantPlantillas}/${0}`);

    }

    const handleModificar = () => {

        if (filaSeleccionada) {
            historyMenu.push(`${SiteRutas.MantPlantillas}/${filaSeleccionada.ID}`);
        } else {
            Notificacion.warning('Debe seleccionar un registro.');
        }

    }

    const handleBorrar = () => {
        if (filaSeleccionada) {
            const optSegopt = optSeg.TOpciones_Menu;
            let validar = validarMenuOpcion(optSegopt.Eliminar.value);
            if (!validar) {
                borrarPlantilla();
            }
        } else {
            Notificacion.error('Debe seleccionar un registro.');
        }
    }

    const borrarPlantilla = () => {

        let resultado = false;

        Swal.fire({
            title: 'Borrar',
            html: '<h4>¿Desea borrar la plantilla seleccionada?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#10a599',
            cancelButtonColor: '#d33',
            confirmButtonText: '<h5><i class="fa fa-check fa-fw"></i> Sí</h5>',
            cancelButtonText: '<h5><i class="fa fa-remove fa-fw"></i> No</h5>',
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {
                resultado = true;
                borrarSeleccionado();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                resultado = false;
            }
        });

        setBorrando(false);

    }

    const borrarSeleccionado = async () => {

        try {
            spinnerModalMostrar(true, 'Anulando', 3);

            const response = await EncaPlantillas_Eliminar_Request(token, filaSeleccionada.ID);

            if (response.Exitoso) {

                setBorrando(true);
                await cargarDatos();
                setFilaSeleccionada(undefined);
                Notificacion.success('Plantilla eliminada satisfactoriamente.');

            } else {
                Notificacion.error('Error: ' + response.Mensaje);
            }

        } catch (ex) {
            Notificacion.error(`Error: ${ex.message}`);
        } finally {
            spinnerModalMostrar(false, '');
        }

    }

    const spinnerModalMostrar = (mostrar, texto, tipo = 3) => {
        setSpinnerModal({ mostrar: mostrar, texto: texto, tipo: tipo });
    }

    const cargarSeguridad = async () => {
        const _MenuNomb = await cargarMenuNombre(Config.Modulo, optSeg.TMenuSistema.Plantillas.value);
        let _menuId = 0;

        if (_MenuNomb.ID != undefined) {
            _menuId = _MenuNomb.ID;
        }

        let _menuOpciones = null;
        if (_menuId > 0) {
            _menuOpciones = await cargarMenuOpciones(Config.Modulo, usuarioS, _menuId);
        }
        setMenuId(_menuId), setMenuOpciones(_menuOpciones);
    }

    //Seguridad
    const cargarMenuOpciones = async (pModuloId, pUsuarioId, pMenuId) => {
        try {

            let listMO = await Obtener_MenuOpciones_Lista_Request(token, pModuloId, pUsuarioId, pMenuId);
            if (listMO.Exitoso === false) {
                return null;
            }
            return listMO.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuOpciones.`);
        }
    }

    const cargarMenuNombre = async (pModulo, pMenuNombre) => {
        try {
            let listMON = await Obtener_MenuNombre_Request(token, pModulo, pMenuNombre);
            if (listMON.Exitoso == false) {
                return null;
            }
            return listMON.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuNombre.`);
        }
    }

    const validarMenuOpcion = (pOpcion) => {
        let validar = false;
        let _menuOpciones = menuOpciones;
        const optSegopt = optSeg.TOpciones_Menu;
        let resultado = _menuOpciones.filter((item) => item.Opcion_Nombre == pOpcion);
        if (resultado.length > 0) {
            if (resultado[0].Opcion_Validar) {
                setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
                validar = true;
            }
        } else {
            setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
            validar = true;
        }
        return validar;
    };

    const handleCerrarModal = () => setShowModalSeguridad(false);

    const onActionResultModal = (pValido) => {
        if (pValido) {
            let _OpcionNom = opcionValidarNombre;
            setShowModalSeguridad(false); setOpcionValidar(0); setOpcionValidarNombre('');
            const _optSegopt = optSeg.TOpciones_Menu;

            switch (_OpcionNom) {
                case _optSegopt.Eliminar.value:
                    borrarPlantilla();
                    break;
                default:
                    break;
            }
        }
    }

    const onRowSelect = (row) => {
        setFilaSeleccionada(row);
    };

    const selectRow = {
        mode: 'radio', clickToSelect: true, hideSelectColumn: true, onSelect: (row, isSelect, rowIndex, e) => {
            onRowSelect(row);
        }, bgColor: '#d73220', style: { color: '#ffffff' }
    };

    useEffect(() => {
        const carga = async () => {
            await cargarDatos()
        }
        carga()
    }, [])

    const ordenarArreglo = (a, b, columna) => {
        if (a[columna] < b[columna]) {
            return -1;
        }
        if (a[columna] > b[columna]) {
            return 1;
        }
        return 0;
    }

    const cargarListaEncaPlantillas = async () => {

        const response = await EncaPlantillas_Listar_Request(token, empresa);

        if (response.Exitoso) {

            if (response.Datos.length > 0 && response.Datos[0].ID === 0) {
                setListaDatos([]);
            } else {
                setListaDatos(response.Datos.sort((a, b) => ordenarArreglo(a, b, 'Nombre')));
            }

        }
        else {
            if (response.Datos.length === 1) {
                setListaDatos([]);
            } else {
                Notificacion.error(`Error: ${response.Mensaje}`);
                volverAtras()
            }
        }

    }

    const cargarDatos = async () => {

        try {
            spinnerModalMostrar(true, 'Cargando Datos');

            await cargarSeguridad();
            await cargarListaEncaPlantillas();


        } catch (ex) {
            Notificacion.error(`Error: ${ex.message}`);
        } finally {
            spinnerModalMostrar(false, '');
        }

    }

    const cellEdit = {
        mode: "click",
        blurToSave: true,
        autoSelectText: true,
        afterSaveCell: (oldValue, newValue, row, column) => {

        },
    };

    return (<Fragment>
        <ListaPlantillasInt
            titulo={'Lista de Plantillas'}
            botones={botones}
            selectRow={selectRow}
            listaDatos={listaDatos}
            columnas={columnas}
            cellEdit={cellEdit}
            borrando={borrando}
        />
        <BotonArriba Delay={10} Visible={100} />
        <ModalSpinner
            selectedModal={SpinnerModal.mostrar}
            contentLabel={'spinnerModalProgress'}
            label={SpinnerModal.texto}
            tipoSpinner={SpinnerModal.tipo}
        />
        <ModalSeguridad
            modalTitle={'Requiere Permisos'}
            menuId={menuId}
            opcionId={opcionValidar}
            show={showModalSeguridad}
            onActionResult={onActionResultModal}
            onHide={handleCerrarModal}
        />
    </Fragment>)

}
export default withRouter(memo(ListaPlantillas));

